import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import api from '../lib/api';
import { formatDate } from '../lib/format';

export default function Consultations() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);
  useEffect(() => { api.get('/consultations').then(r => setItems(r.data)); api.get('/projects').then(r => setProjects(r.data)); }, []);
  const nameOf = (id) => projects.find(p => p.id === id)?.name || '—';
  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-4xl mx-auto">
      <div className="eyebrow">Client Intake</div>
      <h1 className="serif text-[28px] mb-5">Consultation Responses</h1>
      <div className="card-alt p-4 mb-4 text-sm">
        <div className="eyebrow mb-2">How to send</div>
        Share this link with your client: <span className="mono-num text-xs">{window.location.origin}/public/consultation/&lt;project_id&gt;</span>
        <div className="text-xs text-[var(--muted)] mt-1">Open a project to grab its shareable consultation form link.</div>
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="card-cream p-8 text-center text-sm text-[var(--muted)] italic">No consultation responses yet.</div>}
        {items.map(r => (
          <details key={r.id} className="card-cream p-4">
            <summary className="cursor-pointer flex items-center justify-between">
              <div>
                <div className="serif text-[17px]">{r.client_name || '(no name)'}</div>
                <div className="text-xs text-[var(--muted)]">{formatDate(r.submitted_at)} · {nameOf(r.project_id)}</div>
              </div>
            </summary>
            <div className="mt-3 space-y-2 text-sm">
              {Object.entries(r.answers || {}).map(([k, v]) => v && (
                <div key={k}><div className="eyebrow">{k.replace('__',' — ')}</div><div className="mt-0.5">{v}</div></div>
              ))}
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
